import { render, staticRenderFns } from "./LightYourCandle.vue?vue&type=template&id=1bbe21ca&scoped=true&"
import script from "./LightYourCandle.vue?vue&type=script&lang=js&"
export * from "./LightYourCandle.vue?vue&type=script&lang=js&"
import style0 from "./LightYourCandle.vue?vue&type=style&index=0&id=1bbe21ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe21ca",
  null
  
)

export default component.exports